import Box from '@/assets/graphical-elements/box.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const BoxIcon = ({className}: IconProps) => <Box className={cn('fill-current', className)} />
